import React from 'react';
import './ParentScoreItemStatusBlock.scss';
import { useTranslation } from 'react-i18next';

const ParentScoreItemStatusBlock = ({ color, pacing, percentileInfo, i18n }) => {
  const {t} = useTranslation(['teacher_parent_report'], {i18n});

  let backgroundColor = color;
  let label = pacing;
  if (percentileInfo) {
    backgroundColor = percentileInfo.color;
    label = percentileInfo.label;
  }
  
  return (
    <div className={`__status-block`} style={{ backgroundColor }}>
      {t(label)}
    </div>
  )
}

export default ParentScoreItemStatusBlock;